export default function CopyIcon({ done }: { done: boolean }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {done ? (
        <path d="M3.4 8.6 6.4 11.6 12.6 4.6" />
      ) : (
        <>
          <rect x="5.8" y="5.8" width="8.2" height="8.2" rx="1.6" />
          <path d="M3.2 10.4a1.6 1.6 0 0 1-1.6-1.6V3.2a1.6 1.6 0 0 1 1.6-1.6h5.6a1.6 1.6 0 0 1 1.6 1.6" />
        </>
      )}
    </svg>
  )
}
